/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { JobsService } from 'app/core/services/jobs/jobs.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import dayjs from 'dayjs';
import { NgxTippyService } from 'ngx-tippy-wrapper';
import { Subscription } from 'rxjs';
import { badgeColorCode, BadgeOptions } from '../badge/badge.interface';
import _ from 'lodash';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import moment from 'moment';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';

@Component({
  selector: 'zuper-assign-employee',
  templateUrl: './assign-employee.component.html',
  styleUrls: ['./assign-employee.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection:ChangeDetectionStrategy?.OnPush
})
export class AssignEmployeeComponent implements OnInit, OnChanges {
  @Input() options: any = {};
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();
  details: any;
  assignedEmployees: any;
  searchText: string = '';
  teamsList: any = [];
  teamData: any = [];
  mockTeamData: any = [];
  isLazyLoading: boolean = false;
  currentTeamUid: any;
  leftPanelTab: string = 'teams';
  searchType: Array<{key: string;value: string}> = [{key: this.utilityService.getLocaleValue('job.assigment.search.by.employee','Search User'), value: 'EMPLOYEE'},
                                                    {key: this.utilityService.getLocaleValue('text.search_by_team', 'Search By Team'), value: 'TEAM'}];
  type: string = 'TEAM';
  employeeSearchText: string = '';
  employeeList: any = [];
  isEmployeeLoading: boolean =false;
  mockAssignedEmployees: any = [];
  unassignedEmployees: any[] = [];
  teamWorkhoursUpdated: boolean = false;
  employeeSearched: boolean = false;
  update_all_jobs: boolean = false;
  notify: boolean = true;
  teamsPage: number = 1;
  employeesPage: number = 1;
  teamsTotalPage: number = 1;
  employeesTotalPage: number = 1;
  isTeamsLoading: boolean = false;
  totalTeams: number = 0;
  totalEmployees: number = 0;
  filterBySkill: boolean = false;
  filterByTerritory: boolean = false;
  filterByAvailability: boolean = false;
  filterBySkillTeam: boolean = false;
  employeeSubscription: Subscription;
  userListSubscription: Subscription;
  isExpanded: boolean = false;
  companyConfig: any;
  holidays: any;
  holidayList: any = [];
  assignUserFromEmployee: boolean = false;
  unassignUser: boolean = false;
  assignUserFromTeam: boolean = false;
  originalTeamData: any;
  originalWorkHours: any;
  filterTeamBasedOnTerritory: boolean = false;
  clockedInUsers: any;
  companyPolicy: any;
  timelogSummary: any;
  
  constructor(private dataCollectorService: DataCollectorService,
              private utilityService: UtilityService,
              private jobService: JobsService,
              private changeDetectorRef: ChangeDetectorRef,
              private tippyService: NgxTippyService,
              private toast: HotToastService,
              private localStorageService: LocalStorageService,
              private _zuperDialogService: ZuperDialogService ) { }

  ngOnInit(): void {
    this.details = this.options?.details;
    if(this.options?.module === 'PROJECT'){
      this.assignedEmployees = this.details?.project_assigned_to;
      this.mockAssignedEmployees = this.details?.project_assigned_to;
    }else{
      this.assignedEmployees = this.details?.assigned_to;
      this.mockAssignedEmployees = this.details?.assigned_to;
    }
    this.unassignedEmployees = [];
    this.companyConfig = this.localStorageService.getLocalStorage('company_configuration_data');
    this.companyPolicy = this.utilityService.companyPolicy;
    this.filterTeamBasedOnTerritory = this.filterByTerritory = this.details?.service_territory?.territory?.territory_uid && this.isServiceTerritoryEnabled;
    this.notify = this.companyConfig?.jobs?.notify_user_on_assignment ?? true;
    this.getTeams();
    this.getEmployees();
    this.getHolidays();
  }

  get isServiceTerritoryEnabled(): boolean{
    return this.companyConfig?.service_territory?.is_enabled ?? true;
  }


  getTeams(): void{
    let param: any = {
      'filter.user_keyword': this.type==='EMPLOYEE' && !this.utilityService.isEmptyOrUndefined(this.searchText) ? this.searchText : '',
      'filter.keyword': this.type==='TEAM' && !this.utilityService.isEmptyOrUndefined(this.searchText) ? this.searchText : '',
      'page': this.teamsPage,
      'count': 20,
      'sort_by': 'team_name'
    };

    if(this.filterBySkillTeam){
      param = {...param, 'skillset_uid': this.details?.skills?.map((data: any)=> data?.skillset_uid).join()};
    }

    if(this.filterTeamBasedOnTerritory){
      param = {...param, 'filter.service_territory': this.details?.service_territory?.territory?.territory_uid};
    }

    this.dataCollectorService.getData(this.jobService?.jobAPIUrls?.teamSummaryUrl,param).subscribe((response: any)=>{
      this.teamsList = this.teamsPage === 1 ? response?.data : [...this.teamsList,...response?.data];
      this.teamsTotalPage = response?.total_pages;
      this.isTeamsLoading = false;
      this.employeeSearched = false;
      this.totalTeams = response?.total_records;
      this.currentTeamUid = this.teamsList[0]?.team_uid;
      if(this.teamsPage === 1 && this.teamsList?.length){
        this.getworkHours(this.teamsList[0]?.team_uid,true);
      }else{
        this.isLazyLoading = false;
      }
      this.changeDetectorRef.markForCheck();
    },(error: any)=>{
    });
  }

  getEmployees(): void{
    this.isEmployeeLoading = true;
    let param: any = {
      'filter.is_assigned_to_team': true,
      'filter.keyword': this.employeeSearchText || '',
      'page': this.employeesPage,
      'populate_skills': true,
      'populate_teams': true,
      'filter.is_active': true
    };

    if(this.filterBySkill){
      let skillsets = [];
      if(this.details?.skills?.map((data: any)=> data?.skill_uid)?.filter((skill: any)=>!this.utilityService.isEmptyOrUndefined(skill))?.length > 0){
        skillsets = this.details?.skills?.map((data: any)=> data?.skill_uid);
      }else if(this.details?.skills?.map((data: any)=> data?.skillset?.skillset_uid)?.filter((skill: any)=>!this.utilityService.isEmptyOrUndefined(skill))?.length > 0){
        skillsets = this.details?.skills?.map((data: any)=> data?.skillset?.skillset_uid);
      }
      param = {...param, 'filter.skillset_uid': skillsets.join()};
    }
    if(this.filterByTerritory){
      param = {...param, 'filter.service_territory': this.details?.service_territory?.territory?.territory_uid};
    }
    const user_uids = this.mockAssignedEmployees?.map((data: any)=> data?.user?.user_uid);
    if (this.userListSubscription) {
      this.userListSubscription?.unsubscribe();
    }
    this.userListSubscription = this.dataCollectorService.getData(this.jobService?.jobAPIUrls?.allUsersUrl,param).subscribe((response: any)=>{
      let responseData = response?.data?.map((data: any)=>({...data,is_assigned: user_uids?.includes(data?.user_uid)}));
      if (responseData?.length > 0) {
        const params: any = {
          _timestamp: dayjs().unix(),
          from_date: this.details?.scheduled_start_time ? dayjs?.utc(this.details?.scheduled_start_time).format('YYYY-MM-DD'):
                                                         dayjs().utc().format('YYYY-MM-DD'),
          to_date: this.details?.scheduled_end_time ? dayjs?.utc(this.details?.scheduled_end_time).format('YYYY-MM-DD'):
                                                         dayjs().utc().format('YYYY-MM-DD'),
          user_uid: responseData?.map((user: any)=> user?.user_uid)?.join(',')
        };
        this.dataCollectorService.getData(this.jobService?.jobAPIUrls?.teamDetailsUrl,params).subscribe((workHours: any)=>{
          responseData = this.createTeamUserList(responseData, workHours);
          this.updateEmployeeList(response, responseData);
        },(error: any)=>{
          this.updateEmployeeList(response, responseData);
        });
      } else {
        this.updateEmployeeList(response, responseData);
      }
    },(error: any)=>{
      this.employeeList = [];
      this.isEmployeeLoading = false;
      this.changeDetectorRef.markForCheck();
    });
  }

  updateEmployeeList(response: any, users: any[]): void {
    this.employeeList = this.employeesPage === 1 ? users : [...this.employeeList, ...users];
    this.isEmployeeLoading = false;
    this.employeesTotalPage = response?.total_pages;
    this.totalEmployees = response?.total_records;
    this.changeDetectorRef.markForCheck();
  }

  createTeamUserList(users: any,workHours: any): any{
    return users?.filter((user: any)=> user?.is_active === true && this.filterEmployeeSearched(this.searchText,user))?.map((data: any)=>({
      ...data,
      timeoff_conflict: this.getTimeOffConflict(workHours?.data?.find((wh: any)=> wh?.user_uid === data?.user_uid)?.timeoff_request),
      job_conflict: this.getJobConflict( workHours?.data?.find((wh: any)=> wh?.user_uid === data?.user_uid)?.jobs,workHours?.data?.find((wh: any)=> wh?.user_uid === data?.user_uid)?.non_job_events),
      is_assigned: this.checkIfEmployeeAssigned(data,this.teamData),
      workhours: workHours?.data?.find((wh: any)=> wh?.user_uid === data?.user_uid),
      user_skills: workHours?.data?.find((wh: any) =>wh?.user_uid === data?.user_uid)?.skills?.map((skill: any) => ({skillsets: skill}))
    }));
  }

  getworkHours(teamUid: string,isFirstIndex: boolean = false): void{
    const params = {
      _timestamp: dayjs().unix(),
      from_date: this.details?.scheduled_start_time ? dayjs?.utc(this.details?.scheduled_start_time).format('YYYY-MM-DD'):
                                                         dayjs().utc().format('YYYY-MM-DD'),
      to_date: this.details?.scheduled_end_time ? dayjs?.utc(this.details?.scheduled_end_time).format('YYYY-MM-DD'):
                                                         dayjs().utc().format('YYYY-MM-DD'),
      team_uid: teamUid
    };

    if(this.employeeSubscription?.unsubscribe){
      this.employeeSubscription?.unsubscribe();
    }
    this.employeeSubscription = this.dataCollectorService.getData(this.jobService?.getTeamDetails(teamUid)).subscribe((teamDetails: any)=>{
      this.dataCollectorService.getData(this.jobService?.jobAPIUrls?.teamDetailsUrl,params).subscribe((workHours: any)=>{
        this.originalTeamData = _.cloneDeep(teamDetails?.data);
        this.originalWorkHours = _.cloneDeep(workHours);
        this.teamData = _.cloneDeep(teamDetails?.data);
        this.teamData.users = this.createTeamUserList(this.teamData.users,workHours);
        this.mockTeamData = _.cloneDeep(this.teamData);
        this.teamWorkhoursUpdated = true;
        if(isFirstIndex){
          this.isExpanded = true;
        }
        this.changeDetectorRef.markForCheck();
        setTimeout(() => {
          this.isLazyLoading = false;
          this.changeDetectorRef.markForCheck();
        });
      },(error: any)=>{
        this.teamData = [];
        this.isLazyLoading = false;
        this.changeDetectorRef.markForCheck();
      });
    });
  }

  getTimeOffConflict(timeoffs: any): any{
    let isTimeOff = false;
    if(this.details && this.details?.scheduled_start_time){
      const is_timeoff_alert = timeoffs.findIndex((one_timeoff_request: any) =>{
        if(moment(this.details?.scheduled_start_time).isBetween(moment(one_timeoff_request.request_from), moment(one_timeoff_request.request_to), undefined, '[)')
        || moment(this.details?.scheduled_end_time).isBetween(moment(one_timeoff_request.request_from), moment(one_timeoff_request.request_to), undefined, '(]')
        || ((moment(this.details?.scheduled_start_time).isBefore(moment(one_timeoff_request.request_from))
          && moment(this.details?.scheduled_end_time).isAfter(moment(one_timeoff_request.request_to)))) ){
            return true;
          }
        return false;
      });
      if(is_timeoff_alert !== -1){
        isTimeOff =  true;
        this.changeDetectorRef.markForCheck();
      }else{
        isTimeOff = false;
        this.changeDetectorRef.markForCheck();
      }
    }
    return isTimeOff;
  }

  getJobConflict(jobs,nonJobEvents?): any{
    let isConflict = false;
    if(this.details && this.details?.scheduled_start_time){
      _.each(jobs, (job)=>{
        if(job.job_uid !== this.details.job_uid){
          if(moment.utc(this.details.scheduled_start_time).isBetween(moment.utc(job.scheduled_start_time), moment.utc(job.scheduled_end_time), undefined, '[)') || moment.utc(this.details.scheduled_end_time).isBetween(moment.utc(job.scheduled_start_time), moment.utc(job.scheduled_end_time), undefined, '(]') || (moment.utc(this.details.scheduled_start_time).isBefore(moment.utc(job.scheduled_start_time)) && moment.utc(this.details.scheduled_end_time).isAfter(moment.utc(job.scheduled_end_time))) ){
            isConflict = true;
            this.changeDetectorRef.markForCheck();
          }
        }
      });
      if (!this.utilityService.isEmptyOrUndefined(nonJobEvents)) {
        _.each(nonJobEvents, (job)=>{
          if(job.is_available === false){
            if(moment.utc(this.details.scheduled_start_time).isBetween(moment.utc(job.start_time), moment.utc(job.end_time), undefined, '[)') || moment.utc(this.details.scheduled_end_time).isBetween(moment.utc(job.start_time), moment.utc(job.end_time), undefined, '(]') || (moment.utc(this.details.scheduled_start_time).isBefore(moment.utc(job.start_time)) && moment.utc(this.details.scheduled_end_time).isAfter(moment.utc(job.end_time))) ){
              isConflict = true;
              this.changeDetectorRef.markForCheck();
            }
          }
        });
      }
    }
    return isConflict;
  }

  hasValidProfilePicture(profilePicture: string): boolean {
    if (profilePicture) {
      return profilePicture.indexOf('profile_picture.jpg') === -1;
    }
    return false;
  }

  isArrayValue(data): boolean{
    return Array.isArray(data);
  }

  getTagBadgeOptions(tag: string): BadgeOptions{
    const badgeOption: BadgeOptions = {
      type: 'TAG',
      color: badgeColorCode[tag],
      displayKey:tag,
      displayName: tag,
      displayType:'tags',
      extraClass: 'text-sm'
    };
    return badgeOption;
  }

  onExpansionPanelClicked(team: any): void{
    if(this.currentTeamUid !== team?.team_uid){
      this.isLazyLoading = true;
      this.getworkHours(team?.team_uid);
      this.currentTeamUid = team?.team_uid;
      this.changeDetectorRef.markForCheck();
    }
  }
  onPanelExpand(event): any{
    this.isExpanded = true;
    this.changeDetectorRef.markForCheck();
  }

  onPanelCollapse(event): any{
    this.isExpanded = false;
    this.closeTooltip();
    this.changeDetectorRef.markForCheck();
  }

  onSearchValueChange(): void{
      this.isTeamsLoading = true;
      this.employeeSearched = true;
      this.teamsPage = 1;
      this.teamsList = [];
      this.isLazyLoading = true;
      this.getTeams();
      this.changeDetectorRef.markForCheck();
  }

  onModelChange(): void{
    if(this.searchText === ''){
      this.teamsPage = 1;
      this.teamsTotalPage = 1;
      this.isTeamsLoading = true;
      this.employeeSearched = true;
      this.teamsList = [];
      this.isLazyLoading = true;
      this.getTeams();
      this.changeDetectorRef.markForCheck();
    }
  }

  onSearchEmployeeValueChange(): void{
    if(this.employeeSearchText !== ''){
      this.employeeSearched = true;
      this.employeesPage = 1;
      this.getEmployees();
      this.changeDetectorRef.markForCheck();
    }
  }

  onModelEmployeeChange(): void{
    if(this.employeeSearchText === ''){
      this.employeesPage = 1;
      this.employeesTotalPage = 1;
      this.getEmployees();
      this.employeeSearched = false;
      this.changeDetectorRef.markForCheck();
    }
  }

  closeDrawer(): void{
    this.eventEmitter.emit('close');
    this.changeDetectorRef.markForCheck();
  }

  assignFromTeamUser(event,user): void{
    if(this.options?.module === 'JOB' && user?.workhours && (!user.workhours?.start_time || !user?.workhours?.end_time)) {
      const checkUserShiftavailable = this._zuperDialogService.open({
        title: this.utilityService.getLocaleValue('job.details.no_shift_available'),
        type: 'error',
        message: this.utilityService.getLocaleValue('job.details.no_shift_available_assign_them'),
        actions: {
            confirm: {
                show: true,
                label: 'assign.employee',
                color: 'primary',
                confirmDisplayKey: 'assign.employee'
            },
            cancel: {
                show: true,
                label: 'Cancel',
                cancelDisplayKey: 'cancel.text'
            }
        }
      });
      checkUserShiftavailable.afterClosed().subscribe((result: any) => {
        if (result) {
          this.assignFromTeam(event,user);
          this.changeDetectorRef.markForCheck();
        }
      });
    }
    else {
      this.assignFromTeam(event,user);
      this.changeDetectorRef.markForCheck();
    }
    this.assignUserFromTeam = false;
    this.changeDetectorRef.markForCheck();
  }

  assignFromTeam(event,user): void{
    event?.stopPropagation();
    const existingAsignedUser = this.mockAssignedEmployees?.filter((data: any)=> data?.user?.user_uid !== user?.user_uid);
    this.mockAssignedEmployees = [...existingAsignedUser, {team:this.mockTeamData?.team,user:user}];
    if(user?.is_primary === true && !this.isClockedInPrimaryTechIsAssigned){
      this.mockAssignedEmployees.forEach(element => {
        element['is_primary'] = user?.user_uid === element?.user?.user_uid && user?.is_primary === true ? user?.is_primary : false
      });
    }
    this.changeDetectorRef.markForCheck();
    const userIndex = this.mockTeamData.users.findIndex((element: any)=> element?.user_uid === user?.user_uid);
    if(userIndex !== -1){
      this.mockTeamData.users[userIndex] = {...this.mockTeamData.users[userIndex],is_assigned: true};
    }
    this.changeDetectorRef.markForCheck();
  }

  assignFromEmployee(user): void{
    this.dataCollectorService.getData(this.jobService?.getTeamsOfUser(user?.user_uid)).subscribe((response: any)=>{
      this.mockAssignedEmployees = [...this.mockAssignedEmployees, {team:response?.data[0],user:user}];
      this.changeDetectorRef.markForCheck();
      const userIndex = this.employeeList.findIndex((element: any)=> element?.user_uid === user?.user_uid);
      if(userIndex !== -1){
        this.employeeList[userIndex] = {...this.employeeList[userIndex],is_assigned: true};
        this.changeDetectorRef.markForCheck();
      }
      this.assignUserFromEmployee = false;
      this.changeDetectorRef.markForCheck();
    });
  }

  unAssignEmployee(event,user,team?,assignedFrom?): void{
    event?.stopPropagation();
    if(!this.clockedInUsers?.includes(user?.user?.user_uid)){
      let userData: any = {};
      if(user?.user_uid){
        userData = user;
      }else if(user?.user?.user_uid){
        userData = user?.user;
      }
      if(Object.keys(userData).length > 0){
        if(this.assignedEmployees?.findIndex((element: any)=> element?.user?.user_uid === userData?.user_uid) !== -1){
          let unassignedUser: any;
          if(assignedFrom === 'employeeList'){
            unassignedUser = this.mockAssignedEmployees?.find((element: any)=> element?.user?.user_uid === userData?.user_uid);
          }else{
            unassignedUser = this.mockAssignedEmployees?.find((element: any)=> (element?.user?.user_uid === userData?.user_uid) && (element?.team?.team_uid === team?.team_uid));
          }
          this.unassignedEmployees = [...this.unassignedEmployees, unassignedUser];
          this.changeDetectorRef.markForCheck();
        }
        const userIndex = this.mockTeamData?.users?.findIndex((element: any)=> ((element?.user_uid === userData?.user_uid) && (this.mockTeamData?.team?.team_uid === team?.team_uid)));
        if(!this.utilityService.isEmptyOrUndefined(userIndex) && userIndex !== -1){
          this.mockTeamData.users[userIndex] = {...this.mockTeamData?.users[userIndex],is_assigned: false};
          this.changeDetectorRef.markForCheck();
        }
        const employeeIndex = this.employeeList?.findIndex((element: any)=> element?.user_uid === userData?.user_uid);
        if(!this.utilityService.isEmptyOrUndefined(employeeIndex) && employeeIndex !== -1){
          this.employeeList[employeeIndex] = {...this.employeeList[employeeIndex],is_assigned: false};
          this.changeDetectorRef.markForCheck();
        }
        this.mockAssignedEmployees = this.mockAssignedEmployees?.filter((element: any)=> element?.user?.user_uid !== userData?.user_uid);
        this.mockTeamData.users = this.createTeamUserList(this.originalTeamData?.users,this.originalWorkHours);
        this.changeDetectorRef.markForCheck();
      }
      this.unassignUser=false;
      this.changeDetectorRef.markForCheck();
    }
  }

  employeeCardClicked(event): any{
    event?.stopPropagation();
    this.changeDetectorRef.markForCheck();
  }

  assignAllEmployeeInTeam(team,event): void{
    event?.stopPropagation();
    const params = {
      _timestamp: dayjs().unix(),
      date: this.details?.scheduled_start_time ? dayjs().utc(this.details?.scheduled_start_time).tz(this.utilityService?.timeZone).format('YYYY-MM-DD'):
                                                         dayjs().utc().tz(this.utilityService?.timeZone).format('YYYY-MM-DD'),
      team_uid: team?.team_uid
    };


    this.dataCollectorService.getData(this.jobService?.getTeamDetails(team?.team_uid)).subscribe((teamDetails: any)=>{
      this.dataCollectorService.getData(this.jobService?.jobAPIUrls?.teamDetailsUrl,params).subscribe((workHours: any)=>{
        const user_uids = this.mockAssignedEmployees?.map((data: any)=> data?.user?.user_uid);
        const team_uids = this.mockAssignedEmployees?.map((data: any)=> data?.team?.team_uid);
        let teamData: any = {};
        let isNoShiftAvailable: boolean = false;
        let totalUsers: number = 0;
        let totalNoShiftUsers: number = 0;

        if(this.filterByAvailability){
          teamData = this.mockTeamData;
        }
        else {
          teamData = teamDetails?.data;
        }

        teamData.users = teamData?.users?.filter((user: any)=> user?.is_active === true && this.filterEmployeeAssigned(user,teamData))?.map((data: any)=>({
          ...data,
          is_assigned: this.checkIfEmployeeAssigned(data,teamData),
          workhours: workHours?.data?.find((wh: any)=> wh?.user_uid === data?.user_uid)
        }));
        this.changeDetectorRef.markForCheck();
        if(this.options?.module === 'JOB' && teamData?.users?.length > 0) {
          totalUsers = teamData?.users.length;
          let count = 0;
          _.each(teamData?.users, (user: any) =>{
            if(user?.workhours && (!user.workhours?.start_time || !user?.workhours?.end_time)) {
              isNoShiftAvailable = true;
              count++;
            }
          });
          totalNoShiftUsers = count;
          this.changeDetectorRef.markForCheck();
        }

        if(this.options?.module === 'JOB' && isNoShiftAvailable) {
          const checkUserShiftavailable = this._zuperDialogService.open({
            title: this.utilityService.getLocaleValue('job.details.no_shift_available'),
            type: 'error',
            message: totalNoShiftUsers + ' ' + this.utilityService.getLocaleValue('of.label') + ' ' + totalUsers + ' ' + this.utilityService.getLocaleValue('job.details.no_shift_available_assign_all'),
            actions: {
              confirm: {
                show: true,
                label:'assign.employee',
                color: 'primary',
                confirmDisplayKey: 'assign.employee'
              },
              cancel: {
                show: true,
                label: 'Cancel',
                cancelDisplayKey: 'cancel.text'
              }
            }
          });
          checkUserShiftavailable.afterClosed().subscribe((result: any) => {
            if (result) {
              this.assignAllEmployeeInTeamUser(teamData, team, user_uids, workHours);
              this.changeDetectorRef.markForCheck();
            }
          });
        }
        else {
          this.assignAllEmployeeInTeamUser(teamData, team, user_uids, workHours);
          this.changeDetectorRef.markForCheck();
        }
        this.assignUserFromTeam = false;
        this.changeDetectorRef.markForCheck();
      });
    });
  }

  assignAllEmployeeInTeamUser(teamData: any, team: any, user_uids: any, workHours: any): void{
    const unassignedEmployee = teamData?.users?.filter((data: any) => !data?.is_assigned);
    unassignedEmployee.forEach((element: any) => {
      this.mockAssignedEmployees = [...this.mockAssignedEmployees, { team: teamData?.team, user: element }];
    });
    const newPrimaryUser = unassignedEmployee?.find((usr :any)=>usr?.is_primary === true);
    if(newPrimaryUser?.is_primary === true && !this.isClockedInPrimaryTechIsAssigned){
      this.mockAssignedEmployees.forEach(element => {
        element['is_primary'] = newPrimaryUser?.user_uid === element?.user?.user_uid && newPrimaryUser?.is_primary === true ? newPrimaryUser?.is_primary : false
      });
    }
    if (this.currentTeamUid === team?.team_uid) {
      user_uids = this.mockAssignedEmployees?.map((data: any) => data?.user?.user_uid);
      const team_uids = this.mockAssignedEmployees?.map((data: any) => data?.team?.team_uid);
      teamData.users = teamData?.users?.filter((user: any)=> user?.is_active === true && this.filterEmployeeAssigned(user,this.teamData))?.map((data: any) => ({
        ...data,
        is_assigned: this.checkIfEmployeeAssigned(data,this.teamData),
        workhours: workHours?.data?.find((wh: any) => wh?.user_uid === data?.user_uid)
      }));
      this.mockTeamData = teamData;
      this.changeDetectorRef.markForCheck();
    }
  }

  updateTempAssignedEmployees(tab): void{
    const user_uids = this.mockAssignedEmployees?.map((data: any)=> data?.user?.user_uid);
    const team_uids = this.mockAssignedEmployees?.map((data: any) => data?.team?.team_uid);
    switch(tab){
      case 'teams':
        this.mockTeamData.users = this.mockTeamData?.users?.map((data: any)=>({
          ...data,
          is_assigned: user_uids?.includes(data?.user_uid) && team_uids?.includes(this.mockTeamData?.team?.team_uid),
        }));
        this.changeDetectorRef.markForCheck();
        break;
      case 'employees':
        this.employeeList = this.employeeList?.map((data: any)=>({...data,is_assigned: user_uids?.includes(data?.user_uid)}));
        this.changeDetectorRef.markForCheck();
        break;
    }
  }

  loadTeams(): void{
    this.teamsPage = this.teamsPage + 1;
    this.isTeamsLoading = true;
    this.getTeams();
    this.changeDetectorRef.markForCheck();
  }
  loadEmployees(): void{
    this.employeesPage = this.employeesPage + 1;
    this.isEmployeeLoading = true;
    this.getEmployees();
    this.changeDetectorRef.markForCheck();
  }

  emitAssignedEmployee(): void{
    const returnData = {
      assign: this.mockAssignedEmployees,
      unassign: this.unassignedEmployees,
      update_all_jobs: this.update_all_jobs,
      notify: this.notify
    };

    this.eventEmitter.emit(returnData);
    this.changeDetectorRef.markForCheck();
  }

  getTagNames(tagArray: any): string{
    if(tagArray?.length > 1){
     const filteredArray = tagArray.filter((value: any, index: number) => index > 1);
     const tagName: string = filteredArray.map((data: any)=> data?.skillset_name).toString();
      return tagName;
  }
  }

  onSkillFilterValueChange(event,tab): void{
    this.closeTooltip();
    if(tab === 'employee'){
      this.isEmployeeLoading = true;
      this.employeeSearched = true;
      this.employeesPage = 1;
      this.getEmployees();
      this.changeDetectorRef.markForCheck();
    }else if(tab === 'team'){
      this.teamsList = [];
      this.teamsPage = 1;
      this.teamsTotalPage = 1;
      this.isTeamsLoading = true;
      this.employeeSearched = true;
      this.getTeams();
      this.changeDetectorRef.markForCheck();
    }
  }

  closeTooltip(): void{
      this.tippyService.hideAll();
      this.changeDetectorRef.markForCheck();
  }

  OnSearchTypeChange(event): void{
    this.searchText = '';
    this.onSearchValueChange();
    this.changeDetectorRef.markForCheck();
  }

  onAvailabilityFilterValueChange(event): any{
    let users = _.cloneDeep(this.teamData?.users);
    const user_uids = this.mockAssignedEmployees?.map((data: any) => data?.user?.user_uid);
    const team_uids = this.mockAssignedEmployees?.map((data: any) => data?.team?.team_uid);
    users = users?.map((data: any) => ({
      ...data,
      is_assigned: user_uids?.includes(data?.user_uid) && team_uids?.includes(this.teamData?.team?.team_uid)
    }));
    if(this.filterByAvailability){
      this.mockTeamData.users = users.filter((data: any)=> data?.workhours?.available_work_mins && data?.workhours?.available_work_mins > 0 && data?.workhours?.shifts && data?.workhours?.shifts?.length > 0);
            this.changeDetectorRef.markForCheck();
    }else{
      this.mockTeamData.users = users;
            this.changeDetectorRef.markForCheck();
    }

    this.changeDetectorRef.markForCheck();
    this.closeTooltip();
  }

  onFilterClicked(event): any{
    event.stopPropagation();
    this.changeDetectorRef.markForCheck();
  }

  getHolidays(): void{
    const param = {
      limit: 100,
      page: 1,
      sort: 'ASC',
      sort_by: 'created_at'
    };
    this.dataCollectorService.getData(this.jobService.holidayUrl,param).subscribe((response: any)=>{
      this.holidays = response.data;
      if(this.details && this.details?.scheduled_start_time){
        this.setHolidayList();
      }
    });
  }

  setHolidayList(): void{
    _.each(this.holidays, (holiday: any) =>{
      const holidayStart = moment(holiday.date).subtract(23, 'h').subtract(59, 'm');
      const holidayEnd = moment(holiday.date);
      if(moment(holidayStart).isBetween(moment(this.details.scheduled_start_time), moment(this.details.scheduled_end_time), undefined, '[)') || moment(holidayEnd).isBetween(moment(this.details.scheduled_start_time), moment(this.details.scheduled_end_time), undefined, '(]') || (moment(holidayStart).isBefore(moment(this.details.scheduled_start_time)) && moment(holidayEnd).isAfter(moment(this.details.scheduled_end_time)))){
        this.holidayList.push(holiday);
      }
    });

    this.holidayList = this.holidayList.map((data: any)=>data.holiday_name).join(',');
    this.changeDetectorRef.markForCheck();
  }

  checkIfEmployeeAssigned(user,teamData?): any{
    const currentTeam = teamData ?? this.mockTeamData;
    const assignedEmployees = this.mockAssignedEmployees;
    if(assignedEmployees?.findIndex((data: any)=>data?.user?.user_uid === user?.user_uid) !== -1 && assignedEmployees?.find((data: any)=>data?.user?.user_uid === user?.user_uid)?.team?.team_uid === currentTeam?.team?.team_uid){
      return true;
    }
    return false;
  }

  filterEmployeeAssigned(user,teamData?): any{
    const currentTeam = teamData ?? this.mockTeamData;
    const assignedEmployees = this.mockAssignedEmployees;
    if(assignedEmployees?.findIndex((data: any)=>data?.user?.user_uid === user?.user_uid) === -1 ||  (assignedEmployees?.findIndex((data: any)=>data?.user?.user_uid === user?.user_uid) !== -1 && assignedEmployees?.find((data: any)=>data?.user?.user_uid === user?.user_uid)?.team?.team_uid === currentTeam?.team?.team_uid)){
      return true;
    }
    return false;
  }

  filterEmployeeSearched(searchText,user?): any{
    let searchTextValue = searchText?.toLowerCase();
    if(!this.utilityService.isEmptyOrUndefined(searchTextValue) && this.type === 'EMPLOYEE'){
      if (user) {
        const employeeName: string = `${user?.first_name ?? ''} ${user?.last_name ?? ''}`.trim();
        const email: string = user?.email?.toLowerCase() ?? '';
        if (employeeName.toLowerCase().includes(searchTextValue) || email.includes(searchTextValue)) {
          return true;
        }
      }
      return false;
    }else{
      return true;
    }
  }

  markPrimaryTechnician(data: any): void{
    if(!this.isClockedInPrimaryTechIsAssigned){
      let assignedUser = _.cloneDeep(this.mockAssignedEmployees);
      assignedUser = assignedUser.map((user: any)=>({...user,is_primary: user?.user?.user_uid === data?.user?.user_uid}));
      this.mockAssignedEmployees = assignedUser;
      this.changeDetectorRef.markForCheck();
    }
  }

  removePrimaryTechnician(data: any): void{
    if(!this.isClockedInPrimaryTechIsAssigned){
      let assignedUser = _.cloneDeep(this.mockAssignedEmployees);
      assignedUser = assignedUser.map((user: any)=>({...user,is_primary: false}));
      this.mockAssignedEmployees = assignedUser;
      this.changeDetectorRef.markForCheck();
    }
  }

  populatePunchedInUsers(timelogSummary): void{
    const punchedInUsers = [];
    timelogSummary?.forEach((user: any)=>{
      if(user?.timelogs[user?.timelogs?.length -1]?.type === 'CLOCK_IN'){
        punchedInUsers?.push(user?.user?.user_uid);
      }
    });
    console.log(punchedInUsers);
    
    this.clockedInUsers = punchedInUsers;
  }

  getTimelogSummary(): void {
    const jobId = this.options?.module === 'JOB' && this.options?.details?.job_uid ? this.options?.details?.job_uid : null;
    if(jobId){
      this.dataCollectorService.getData(this.jobService.getTimelogUrl(jobId)).subscribe((response: any) => {
        this.timelogSummary = response?.data ?? [];
        this.populatePunchedInUsers(this.timelogSummary);
        this.changeDetectorRef.markForCheck();
      });
    }
  }

  get isClockedInPrimaryTechIsAssigned(): boolean{
    const assignedUser = [...new Set(this.mockAssignedEmployees.map((data: any)=> data?.user?.user_uid))];
    let isClockedIn = false;
    assignedUser.forEach((usr: any)=>{
      if(this.clockedInUsers?.includes(usr)){
        isClockedIn = true;
      }
    })
    return isClockedIn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if('options' in changes){
      this.options = changes?.options?.currentValue;
      this.companyConfig = this.localStorageService.getLocalStorage('company_configuration_data');
      this.companyPolicy = this.utilityService.companyPolicy;
      if(this.companyPolicy?.enable_v2_timelog &&  this.companyConfig?.jobs?.job_timelog?.is_enabled && this.options?.timelogSummary?.length > 0){
        this.populatePunchedInUsers(this.options?.timelogSummary);
      }else if(this.companyPolicy?.enable_v2_timelog &&  this.companyConfig?.jobs?.job_timelog?.is_enabled){
        this.getTimelogSummary();
      }
      this.changeDetectorRef.markForCheck();
    }
  }
}
